module.exports = __webpack_public_path__ + "img/yctiwy-14.057c8452.jpg";